import useApiQuery from '@hooks/useApiQuery';
import QueryKeys from '@src/constants/queryKeys';

export default () =>
  useApiQuery<string[]>({
    queryKey: [QueryKeys.deviceTypes],
    apiPath: '/devices/types',
    method: 'GET',
    useV2API: true,
  });
